import { useI18n } from "@/i18n/I18nContext";
import { Globe } from "lucide-react";

export default function LanguageToggle({ variant = "default" }) {
  const { lang, setLang } = useI18n();
  const toggle = () => setLang(lang === "en" ? "es" : "en");
  const compact = variant === "compact";
  return (
    <button
      type="button"
      onClick={toggle}
      className={
        compact
          ? "inline-flex items-center gap-1 rounded-md border border-[#E0E4E2] bg-white px-2 py-1 text-[11px] font-bold uppercase tracking-wider text-[#11322A] hover:border-[#11322A]"
          : "inline-flex items-center gap-1.5 rounded-lg border border-[#E0E4E2] bg-white px-3 py-2 text-xs font-bold text-[#11322A] hover:border-[#11322A]"
      }
      data-testid="language-toggle"
      aria-label="Toggle language"
      title={lang === "en" ? "Cambiar a Español" : "Switch to English"}
    >
      <Globe className={compact ? "h-3 w-3" : "h-3.5 w-3.5"} />
      {lang === "en" ? "ES" : "EN"}
    </button>
  );
}
